import "@hotwired/turbo";

const WELCOME_TEMPLATE_ID = "welcome-bottomsheet-template";
const SHOW_DELAY_MS = 1000;

function triggerWelcomeBottomsheet() {
  const template = document.getElementById(WELCOME_TEMPLATE_ID);
  if (!template) return;

  const streamHtml = template.innerHTML.trim();
  // Remove template so it doesn't fire again on subsequent turbo:load events.
  template.remove();

  if (!streamHtml) return;

  setTimeout(() => {
    if (window.Turbo && typeof window.Turbo.renderStreamMessage === "function") {
      window.Turbo.renderStreamMessage(streamHtml);
    }
  }, SHOW_DELAY_MS);
}

document.addEventListener("turbo:load", triggerWelcomeBottomsheet);

